import { memo } from 'react';
import { faFileCheck, faFileUpload, faFileExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FileItem } from './types/types';
import { FILE_STATUS } from './utils/constants';
import { Icon } from '../../atoms/Icon';

const FileStatusIcon = memo(({ status }: { status: FileItem['status'] }) => {
  // Per design: only show icons for uploading, uploaded, and error states
  // Always render a Box to maintain consistent alignment

  if (status === FILE_STATUS.UPLOADING) {
    return <Icon icon={faFileUpload} fixedWidth />;
  }

  if (status === FILE_STATUS.ERROR) {
    return <Icon icon={faFileExclamation} colorScheme="red" fixedWidth />;
  }

  return <Icon icon={faFileCheck} fixedWidth />;
});

FileStatusIcon.displayName = 'FileStatusIcon';

export default FileStatusIcon;
